import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((_theme) => ({
  chartContainer: {
    position: 'relative',
    overflow: 'hidden',
},
sliderContainer: {
    margin: '20px 0',
    padding: '0 30px',
    position: 'relative',
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
},
sliderWrapper: {
    position: 'relative',
    height: '8px',
    display: 'flex',
    alignItems: 'center',
},
slider: {
    WebkitAppearance: 'none',
    width: '100%',
    height: '4px',
    background: '#e0e0e0',
    borderRadius: '2px',
    outline: 'none',
    '&::-webkit-slider-thumb': {
        WebkitAppearance: 'none',
        width: '20px',
        height: '20px',
        background: '#0067A1',
        borderRadius: '50%',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        '&:hover': {
            transform: 'scale(1.1)',
            background: '#004d80',
        },
        '&:active': {
            transform: 'scale(1)',
        }
    },
},
pageIndicator: {
    position: 'absolute',
    right: '0',
    bottom: '-24px',
    color: '#666',
    fontSize: '0.8rem',
    fontWeight: 400,
    fontFamily: 'system-ui, sans-serif',
    '& span': {
        color: '#0067A1',
        fontWeight: 500,
    }
},
progressTrack: {
    position: 'absolute',
    height: '4px',
    background: '#0067A1',
    borderRadius: '2px',
    transition: 'width 0.3s ease',
},
}));

const ScrollBarForGraph = ({totalPages, currentPage, setCurrentPage}) => {
    const classes = useStyles();

    const handleCurrentPageChange = (e) => {
        setCurrentPage(parseInt(e.target.value, 10));
    };

    return(
        totalPages > 1 && (
            <div className={classes.sliderContainer}>
                <div className={classes.sliderWrapper}>
                    <div
                        className={classes.progressTrack}
                        style={{
                            width: `${((currentPage + 1) / totalPages) * 100}%`,
                            opacity: 0.3
                        }}
                    />
                    <input
                        type="range"
                        min="0"
                        max={totalPages - 1}
                        value={currentPage}
                        onChange={handleCurrentPageChange}
                        className={classes.slider}
                    />
                </div>
                <div className={classes.pageIndicator}>
                    <span>{currentPage + 1}</span> / {totalPages}
                </div>
            </div>
        )
    );
};

export default ScrollBarForGraph;
